import { lazy } from 'react';

export const CreditApplicationsPage = lazy(
  () => import('./ui/CreditApplicationsPage/CreditApplicationsPage'),
);

export const CreditApplicationsDetailsPage = lazy(
  () =>
    import('./ui/CreditApplicationsDetailsPage/CreditApplicationsDetailsPage'),
);

export const CreditApplicationFormPage = lazy(
  () => import('./ui/CreditApplicationFormPage/CreditApplicationFormPage'),
);

export const CreditApplicationSmartFormPage = lazy(
  () =>
    import(
      './ui/CreditApplicationSmartFormPage/CreditApplicationSmartFormPage'
    ),
);
